//GeneratorFlag:[NoChange]
import Position from './position';
import Branch from './branch';
import Person from './person';

export default {Position, Branch, Person}
export{Position, Branch, Person}